import React from 'react';

const InnerContainer = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex-auto flex items-center w-full h-full relative overflow-hidden min-w-0">
      {children}
    </div>
  );
};

export default InnerContainer;
